// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__20F0r","label":"Section_label__3n1OD","contentWrap":"Section_contentWrap__18Im6","footer":"Section_footer__3toBd","footerInner":"Section_footerInner__1Iyzz"};